import type {SlotGameStore, BaseComponentConfig} from "@gamzix/slot_core";

class FreeSpinsGameComponent extends SlotGame.src.component.FreeSpinsGameComponent {
    static events = {
        START_INTRO_TRANSITION: "FreeSpinsGameComponent.START_INTRO_TRANSITION",
        START_HIDE_INTRO_POPUP: "FreeSpinsGameComponent.START_HIDE_INTRO_POPUP",
        END_INTRO_TRANSITION: "FreeSpinsGameComponent.END_INTRO_TRANSITION",
        START_OUTRO_TRANSITION: "FreeSpinsGameComponent.START_OUTRO_TRANSITION",
        END_OUTRO_TRANSITION: "FreeSpinsGameComponent.END_OUTRO_TRANSITION",
        OUTRO_POPUP_START_COUNT: "FreeSpinsGameComponent.OUTRO_POPUP_START_COUNT",
        OUTRO_POPUP_END_COUNT: "FreeSpinsGameComponent.OUTRO_POPUP_END_COUNT",
        SHOW_WIN_SCATTER_LINE: "FreeSpinsGameComponent.SHOW_WIN_SCATTER_LINE"
    }

    override isStarted() {
        return this.store.gameData.freeSpinsGame.isStarted() || this.isAddedFreeSpins;
    }

    constructor(config: BaseComponentConfig) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isEnglishLang: () => (<SlotGameStore>game.store).language === "en"
        };

        this.text_checkers = {
            ...super.getTextCheckers(),

            GET_TOTAL_WIN_NUMBER: () => this.store.toFormatMoney(this.store.gameData.winAmount),
            FREE_SPINS_AMOUNT: () => {
                return this.isAddedFreeSpins ? this.store.gameData.freeSpinsGame.added : 10
            }
        };
    }

    async showStartPopup() {
        game.emit(FreeSpinsGameComponent.events.START_INTRO_TRANSITION);

        const container = game.tree.findByName('freeSpinsGame.intro_popup_container');

        container.options.visible = true;

        // for update FREE_SPINS_AMOUNT
        this.onChangeOrientation();

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 0, to: 1, time: 500, timeWait: 0});

        await Promise.race([
            game.utils.delay(this.isAddedFreeSpins ? 3000 : 10000),
            this.waitClick(),
            game.onceDataPromise('Button.clicked', {
                component: 'freeSpinsGame',
                name: 'freeSpinsGame.intro_popup_container.skip_btn'
            })
        ]);

        game.emit(FreeSpinsGameComponent.events.START_HIDE_INTRO_POPUP);

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 1, to: 0, time: 500, timeWait: 0});

        game.emit(FreeSpinsGameComponent.events.END_INTRO_TRANSITION);
    }

    async showFinishPopup() {
        game.emit(FreeSpinsGameComponent.events.START_OUTRO_TRANSITION);

        await this.showOutroPopup();

        game.emit(FreeSpinsGameComponent.events.END_OUTRO_TRANSITION);
    }

    async showOutroPopup() {
        const container = game.tree.findByName('freeSpinsGame.outro_popup_container');
        const totalWin = game.tree.findByName('freeSpinsGame.outro_popup_container.total_win_value');

        container.options.visible = true;

        totalWin.options.text = this.store.toFormatMoney(0);
        totalWin.updateViewOptions();

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 0, to: 1, time: 500, timeWait: 0});

        game.emit(FreeSpinsGameComponent.events.OUTRO_POPUP_START_COUNT);

        await Promise.race([
            new Promise<void>(async resolve => {
                await game.utils.GameUtils.playCounterAnimation(totalWin, {
                    from: 0,
                    to: this.store.gameData.winAmount,
                    time: 3000,
                    timeWait: 0,
                    minTimeForUpdate: 0
                });
                game.emit(FreeSpinsGameComponent.events.OUTRO_POPUP_END_COUNT);
                await game.utils.delay(10000);
                resolve();
            }),
            this.waitClick(),
            game.onceDataPromise('Button.clicked', {
                component: 'freeSpinsGame',
                name: 'freeSpinsGame.outro_popup_container.skip_btn'
            })
        ]);
        game.emit(FreeSpinsGameComponent.events.OUTRO_POPUP_END_COUNT);

        game.utils.removeCall(totalWin._tween);

        totalWin.options.text = this.store.toFormatMoney(this.store.gameData.winAmount);
        totalWin.updateViewOptions();

        await game.utils.delay(500);
        await game.utils.GameUtils.playAlphaAnimation(container, {from: 1, to: 0, time: 500, timeWait: 0});
    }

    get store(): SlotGameStore {
        return (<SlotGameStore>game.store)
    }

    get isAddedFreeSpins(): boolean {
        return Boolean(this.store.gameData.freeSpinsGame.added && this.store.gameData.freeSpinsGame.isPlaying())
    }

    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            SHOW_WIN: {
                ...super.getFSMHandlers()['SHOW_WIN'],
                showWinPositions: {
                    on: () => {
                        //This is a winning line that turns into a fs
                        if (this.store.gameData.prevMode === "main" && this.store.gameData.state === "freespin") {
                            game.emit(FreeSpinsGameComponent.events.SHOW_WIN_SCATTER_LINE);
                        }
                    }
                }
            }
        }
    }
}

export {FreeSpinsGameComponent};

//@ts-ignore
Game.src.component.FreeSpinsGameComponent = FreeSpinsGameComponent;